import { render, staticRenderFns } from "./BuySection.vue?vue&type=template&id=02fc9cb5&scoped=true&"
import script from "./BuySection.vue?vue&type=script&lang=js&"
export * from "./BuySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fc9cb5",
  null
  
)

export default component.exports